import ordinales  from "ordinales-js";

export function ordenCuota(num) {
  return parseInt(num) == 0 ? "Cuota Inicial" : ordinales.toOrdinal(num, 'f') + " cuota";
}